export const BaseUrlMy = 'https://simplifii-assinment-login-flow.onrender.com'
export const BaseUrl = 'https://colo-dev.infollion.com/api/v1'
